<section class="min-h-screen">
  <!-- Page Header -->
  <div class="mb-6 flex items-start justify-between">
    <div>
      <button (click)="goBack()"
        class="flex items-center gap-1.5 text-xs font-semibold text-slate-500 dark:text-slate-400 hover:text-primary-800 dark:hover:text-primary-400 transition-colors mb-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
        Back to Products
      </button>
      <h1 class="text-2xl font-bold tracking-tight text-primary-800 dark:text-primary-400">{{ productName() }}</h1>
      <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">Product details and analytics</p>
    </div>
  </div>

  <!-- Tab Navigation -->
  <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm mb-6">
    <div class="flex items-center border-b border-slate-200 dark:border-slate-700">
      @for (menuItem of menuItems; track $index) {
      <button
        (click)="onMenuChange($index)"
        class="px-6 py-3.5 text-xs font-bold transition-all border-b-2 uppercase tracking-wide"
        [class]="activeMenu === $index ? 'border-primary-800 text-primary-800 dark:text-primary-400' : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:text-slate-300 hover:border-slate-300 dark:border-slate-600'">
        {{ menuItem }}
      </button>
      }
    </div>
  </div>

  <!-- Content Area -->
  <div>
    <router-outlet></router-outlet>
  </div>
</section>
